export function createRenderbuffer(gl: WebGL2RenderingContext): WebGLRenderbuffer {
  const b = gl.createRenderbuffer();
  if (b == null) {
    throw Error("failed to create renderbuffer");
  }
  return b;
}
